import { ButtonColor } from '@design-system/components/button/button.css';
import { IconButton } from '@design-system/components/button/iconButton';
import { Typography } from '@design-system/components/typography/typography';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export const Header = ({
  title,
  subtitle,
  cta,
}: {
  title: string;
  subtitle?: string;
  link?: string;
  cta?: Array<{
    icon: IconProp;
    onClick: () => void;
    content?: string;
    className?: string;
    disabled?: boolean;
    color?: ButtonColor;
  }>;
}) => (
  <div className="flex flex-col md:flex-row justify-between pb-4">
    <div className="flex flex-col gap-2">
      <Typography variant="headline" size="large">
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body" size="medium" color="N-100">
          {subtitle}
        </Typography>
      )}
    </div>
    {!cta ? null : (
      <div className="flex gap-4">
        {cta.map((item, index) => (
          <IconButton
            key={index}
            disabled={item.disabled}
            icon={item.icon}
            color={item.color || 'neutral'}
            onClick={item.onClick}
          >
            {item.content || null}
          </IconButton>
        ))}
      </div>
    )}
  </div>
);
